import { NodeViewProps } from '@tiptap/core'
import React, { FC, forwardRef } from 'react'

import AddColumnLeftIcon from '~icons/editor/add-column-left.svg'
import AddColumnRightIcon from '~icons/editor/add-column-right.svg'
import AddRowAboveIcon from '~icons/editor/add-row-above.svg'
import AddRowBelowIcon from '~icons/editor/add-row-below.svg'
import DeleteColumnIcon from '~icons/editor/delete-column.svg'
import DeleteRowIcon from '~icons/editor/delete-row.svg'
import DeleteTableIcon from '~icons/editor/delete-table.svg'
import { preventDefault } from '~lib/helpers'
import Menu, { MenuProps } from '~lib/ui-kit/Menu'
import { MenuVariant } from '~lib/ui-kit/MenuLayout'
import Divider from '~shared/ui/Divider'

interface TableMenuProps extends MenuProps {
  onUpdate: VoidFunction
  editor: NodeViewProps['editor']
  position: number
}

const TableMenu: FC<React.PropsWithChildren<TableMenuProps>> = forwardRef<HTMLUListElement, TableMenuProps>(
  ({ onUpdate, editor, position, ...props }, ref) => {
    function handleAddColumnBefore() {
      editor.chain().focus(position).addColumnBefore().run()
      onUpdate()
    }

    function handleAddColumnAfter() {
      editor.chain().focus(position).addColumnAfter().run()
      onUpdate()
    }

    function handleDeleteColumn() {
      editor.chain().focus(position).deleteColumn().run()
      onUpdate()
    }

    const handleAddRowBefore = () => {
      editor.chain().focus(position).addRowBefore().run()
      onUpdate()
    }

    const handleAddRowAfter = () => {
      editor.chain().focus(position).addRowAfter().run()
      onUpdate()
    }

    const handleDeleteRow = () => {
      editor.chain().focus(position).deleteRow().run()
      onUpdate()
    }

    const handleDeleteTable = () => {
      editor.chain().focus(position).deleteTable().run()
      onUpdate()
    }

    return (
      <Menu ref={ref} {...props} variant={MenuVariant.CONTEXT}>
        <Menu.Item icon={<AddRowAboveIcon />} onMouseDown={preventDefault} onClick={handleAddRowBefore}>
          Insert row above
        </Menu.Item>
        <Menu.Item icon={<AddRowBelowIcon />} onMouseDown={preventDefault} onClick={handleAddRowAfter}>
          Insert row below
        </Menu.Item>
        <Menu.Item icon={<AddColumnLeftIcon />} onMouseDown={preventDefault} onClick={handleAddColumnBefore}>
          Insert column left
        </Menu.Item>
        <Menu.Item icon={<AddColumnRightIcon />} onMouseDown={preventDefault} onClick={handleAddColumnAfter}>
          Insert column right
        </Menu.Item>
        <Divider />
        <Menu.Item icon={<DeleteRowIcon />} onMouseDown={preventDefault} onClick={handleDeleteRow}>
          Delete row
        </Menu.Item>
        <Menu.Item icon={<DeleteColumnIcon />} onMouseDown={preventDefault} onClick={handleDeleteColumn}>
          Delete column
        </Menu.Item>
        <Menu.Item icon={<DeleteTableIcon />} onMouseDown={preventDefault} onClick={handleDeleteTable}>
          Delete table
        </Menu.Item>
      </Menu>
    )
  }
)

export default TableMenu
